<div class="logout">
    <div class="logout__content">
        <h4 class="heading-4">Your session is about to end</h4>

        <p class="body-1">
            You've been inactive for a while. For your security, we'll automatically sign you out in approximately 1
            minute. You may choose "Stay signed in" to continue or sign out if you're done.
        </p>

        <div class="logout__actions">
            <button mat-stroked-button>Sign out</button>
            <button mat-raised-button routerLink="/login" (click)="closeOverlay()">Stay signed in</button>
        </div>
    </div>
</div>
